// @flow
import { OFFER_LEGAL_INFORMATION } from 'Client/cms/toolkit/constants';
import { OfferLegalInformationLine } from 'Components/lines/offer-legal-information-line/OfferLegalInformationLine';
import { offerLegalInformationResolver } from './offerLegalInformation.resolver';

export const offerLegalInformationDescriptor = {
  name: OFFER_LEGAL_INFORMATION,
  component: OfferLegalInformationLine,
  resolve: offerLegalInformationResolver.resolve,
};
